import React from 'react';
import { Box, Divider } from '@wix/design-system';
import { InfoLine } from '../InfoSection';
export const LineItem = React.memo(({ formatMoney, isLast = false, lineItem, showTax = false, t }) => {
    const Line = (props) => (React.createElement(InfoLine, { clearPadding: true, ...props }));
    const renderProductInfo = () => {
        const selectedOptions = Object.values(lineItem.metadata?.selectedOptions ?? {});
        return (React.createElement(Box, { display: "flex", direction: "vertical" },
            React.createElement(Line, { weight: "bold" }, lineItem.name),
            selectedOptions.length ? (React.createElement(Line, null, selectedOptions.join('; '))) : null,
            lineItem.description ? (React.createElement(Line, { wordBreak: "break-word" }, lineItem.description)) : null,
            React.createElement(Line, { marginTop: "12px" }, t('price-quote.mobile-view.line-items.list.item.quantity', {
                price: formatMoney(lineItem.price),
                quantity: lineItem.quantity,
            }))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { direction: "horizontal" },
            React.createElement(Box, { flex: 1, marginRight: "12px" }, renderProductInfo()),
            React.createElement(Line, { weight: "bold" }, formatMoney(showTax
                ? lineItem.taxedTotal
                : lineItem.quantity * lineItem.price))),
        showTax && lineItem.taxes.length ? (React.createElement(Line, null, lineItem.taxes
            .map((tax) => t('price-quote.view.totals.tax-rate', {
            name: tax.name,
            rate: tax.rate,
        }))
            .join(' • '))) : null,
        !isLast && (React.createElement(Box, { marginTop: "20px", marginBottom: "20px" },
            React.createElement(Divider, null)))));
});
//# sourceMappingURL=LineItem.js.map